import { useTranslation } from 'react-i18next';

const AIConversationStarter = () => {
    const { t } = useTranslation();

    return (
        <div className="d-flex align-items-end justify-content-center text-center h-100">
            <div className='fs-7'>
                {t("AIConversationStarter.line1")}
            </div>
        </div>
    );
};

export default AIConversationStarter;
